import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(username, password) {
  return yield oncallFetch("/api/oncall/partners/users/change-password", {
    username,
    password,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/users/change-password.js